import _ from "i18n";
export const budgetManagementMonths = [
  {legend: _('JANUARY')},
  {legend: _('FEBRUARY')},
  {legend: _('MARCH')},
  {legend: _('APRIL')},
  {legend: _('MAY')},
  {legend: _('JUNE')},
  {legend: _('JULY')},
  {legend: _('AUGUST')},
  {legend: _('SEPTEMBER')},
  {legend: _('OCTOBER')},
  {legend: _('NOVEMBER')},
  {legend: _('DECEMBER')},
];



// WEBPACK FOOTER //
// ./app/constants/Months.js